import { render, staticRenderFns } from "./HeaderBlackHole.vue?vue&type=template&id=41ba4026&scoped=true"
import script from "./HeaderBlackHole.vue?vue&type=script&lang=js"
export * from "./HeaderBlackHole.vue?vue&type=script&lang=js"
import style0 from "./HeaderBlackHole.vue?vue&type=style&index=0&id=41ba4026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ba4026",
  null
  
)

export default component.exports